<div
  class="grid min-h-screen w-full grid-cols-[100%] grid-rows-[auto,1fr] bg-white font-roboto"
>
  <!-- Header com position sticky -->
  <div class="sticky top-0 z-50" id="header">
    <mw-store-header (toggleMenuCollapse)="toggleMenuCollapse()" />
    <mw-store-navbar
      [isCollapsed]="isMenuCollapsed()"
      (toggleCollapse)="toggleMenuCollapse()"
    />
  </div>

  <!-- Conteúdo Principal -->
  <main
    class="mx-auto min-h-full w-full flex-1 overflow-x-hidden p-4 md:px-10 md:pt-0"
  >
    <router-outlet />
  </main>
</div>
